export const colors = {
  bg: "#2D2D23",
  text: "#F2E1D1", 
  primary: "#44795A",
  accent: "#999862",
};
